import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 flex w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-5/12 h-5 mr-4 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/12 h-5 mr-2 rounded-full skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/12 h-5 rounded-full skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-10 h-5 ml-auto rounded-full skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center opacity-0" }, [
    /*#__PURE__*/_createElementVNode("h4", null, " "),
    /*#__PURE__*/_createElementVNode("div", { class: "my-auto ml-4 chip" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
        /*#__PURE__*/_createElementVNode("p", null, " ")
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "relative h-20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 flex flex-col w-full space-y-2 max-h-20" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-5 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-5 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full h-5 skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "overflow-x-hidden overflow-y-auto opacity-0 overflow-ellipsis max-h-20" }, [
    /*#__PURE__*/_createElementVNode("div", null, " ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}